export default {
  namespaced: true,
  state     : {
    employee_study_courses: {
      content: {
        search    : '',
        pagination: {
          sortBy     : 'id',
          rowsPerPage: 500,
          page       : 1,
        },
        headers: [
          {text: 'Курс', value: 'name', sort: true},
          {text: 'Дата постановки', value: 'statement_date', sort: true},
          {text: 'Статус', value: 'status', sort: true},
          {text: 'Пройдено', value: 'completed_percent', sort: true},
          {text: 'Ср. балл', value: 'average_users_points', sort: true},
          {text: 'Времени затрачено', value: 'average_users_time', sort: true},
        ],
        body: [
        ],
      },
    },
    showed_courses_filter: false,
  },
  getters: {
    showed_courses_filter          : ({showed_courses_filter}) => showed_courses_filter,
    employee_study_courses         : ({employee_study_courses}) => employee_study_courses,
    employee_study_courses_filtered: ({employee_study_courses}, getters, rootState) => {
      const search = rootState.employee_study.search;

      let answer = employee_study_courses;
      answer.content.body = answer.content.body.filter((value) => {
        return value.name.toLowerCase().includes(search.toLowerCase());
      });

      return answer;
    },
    get_course_by_id: ({employee_study_courses}, {}, {route}, rootGetter) => {
      let current_id = route.query.course;
      return employee_study_courses.content.body.find((item)=> item.id === current_id);
    },
  },
  mutations: {
    TOGGLE_COURSES_FILTER(state) {
      state.showed_courses_filter = !state.showed_courses_filter;
    },
    SHOW_COURSES_NUMBER(state, selected) {
      const table = state.employee_study_courses.content;
      table.pagination.rowsPerPage = selected;
    },
    SET_COURSES_PAGINATION(state, value) {
      let table = state.employee_study_courses.content;
      table.pagination = value;
    },
    SET_COURSES_PAGE(state, value) {
      let table = state.employee_study_courses.content;
      table.pagination.page = value;
    },
    CHANGE_COURSES_SORT(state, column) {
      let table = state.employee_study_courses.content;
      if (table.pagination.sortBy === column) {
        table.pagination.descending = !table.pagination.descending;
      } else {
        table.pagination.sortBy = column;
        table.pagination.descending = false;
      }
    },
    SEARCH_COURSES(state, value) {
      state.employee_study_courses.content.search = value;
    },

    SET_COURSES(state, value) {
      let new_value = [];
      value.forEach((item, idx)=>{
        new_value.push({});
        new_value[idx].course_id = item.course_id;
        new_value[idx].name = item.name;
        new_value[idx].statement_date = item.statement_date;
        new_value[idx].status = item.status;
        new_value[idx].completed_percent = `${item.completed_users_count} (${item.completed_percent}%)`;
        new_value[idx].average_users_points = item.average_users_points;
        new_value[idx].average_users_time = item.average_users_time;
      });
      state.employee_study_courses.content.body = new_value;
    },
    SET_PAGINATION(state, value) {
      state.employee_study_courses.content.pagination = {...state.employee_study_courses.content.pagination, ...value};
    },
  },
  actions: {
    async change_course_per_page({commit}, event) {
      commit('SHOW_COURSES_NUMBER', event);
      commit('SET_COURSES_PAGE', 1);
    },
  },
};
